import { Container, Flex } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export function Page({
  children,
  flex = false,
}: PropsWithChildren<{ flex?: boolean }>) {
  return flex ? (
    <Flex
      bg="brand.gray.90"
      direction="column"
      flex={1}
      justifyContent="space-between"
      maxH="100%"
      overflow="auto"
      p={4}
      w="100%"
    >
      {children}
    </Flex>
  ) : (
    <Container
      bg="brand.gray.90"
      maxW="100%"
      overflow="auto"
      p={4}
      w="100%"
    >
      {children}
    </Container>
  );
}
